module.exports = __webpack_public_path__ + "img/SA.3227a92d.svg";